import formsSelect from "./forms/_select.js";
import otherHeadAlert from "./others/_head-alert.js";
import buttonsFavorite from "./buttons/_favorite.js";
import basicsBadge from './basics/_badge.js';
import othersSearchMenu from "./others/_search-menu.js";
import othersSearchList from "./others/_search-list.js";
import othersBlockLinks from "./others/_block-links.js";
import othersFloatingContent from "./others/_floating-content.js";
import cardsEstate from "./cards/_estate.js";
import rowContactFields from "./forms/_row-contact-fields.js";

const components = () => {
    formsSelect();
    otherHeadAlert();
    buttonsFavorite();
    basicsBadge();
    othersSearchMenu();
    othersSearchList();
    othersBlockLinks();
    othersFloatingContent();
    cardsEstate();
    rowContactFields()
}
export default components;
